import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options'],
  data: function () {
    return {
      datacollection: {
        labels: [],
        datasets: [
          {
            data: []
          }
        ]
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    constructChartData () {
      var self = this

      self.datacollection.labels = self.options.map((val, i) => {
        return {
          val
        }
      })

      self.datacollection.datasets[0].data = self.options.map((val, i) => {
        return {
          i
        }
      })
    }
  }
}
